/*eslint-disable*/
/* eslint-disable quotes */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import FormHelperText from "@material-ui/core/FormHelperText";

import styles from "assets/jss/material-kit-react/components/customInputStyle.js";

const useStyles = makeStyles(styles);

export default function CustomInputWithValidation(props) {
  const classes = useStyles();
  const {
    formControlProps,
    labelText,
    id,
    labelProps,
    inputProps,
    error,
    white,
    inputRootCustomClasses,
    success,
    onChange,
    value,
    isSubmitted,
  } = props;

  const showError = isSubmitted && (!value || value.trim() === "");

  const labelClasses = classNames({
    [" " + classes.labelRootError]: showError || error,
    [" " + classes.labelRootSuccess]: success && !error && !showError,
  });

  const underlineClasses = classNames({
    [classes.underlineError]: showError || error,
    [classes.underlineSuccess]: success && !error && !showError,
    [classes.underline]: true,
    [classes.whiteUnderline]: white,
  });

  const marginTop = classNames({
    [inputRootCustomClasses]: inputRootCustomClasses !== undefined,
  });

  const inputClasses = classNames({
    [classes.input]: true,
    [classes.whiteInput]: white,
  });

  var formControlClasses;
  if (formControlProps !== undefined) {
    formControlClasses = classNames(
      formControlProps.className,
      classes.formControl
    );
  } else {
    formControlClasses = classes.formControl;
  }

  return (
    <FormControl {...formControlProps} className={formControlClasses} error={showError || error}>
      {labelText !== undefined ? (
        <InputLabel
          className={classes.labelRoot + " " + labelClasses}
          htmlFor={id}
          {...labelProps}
        >
          {labelText}
        </InputLabel>
      ) : null}
      <Input
        classes={{
          input: inputClasses,
          root: marginTop,
          disabled: classes.disabled,
          underline: underlineClasses,
        }}
        id={id}
        value={value}
        onChange={onChange}
        {...inputProps}
      />
      {showError && (
        <FormHelperText>This field is required</FormHelperText>
      )}
    </FormControl>
  );
}

CustomInputWithValidation.propTypes = {
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  inputRootCustomClasses: PropTypes.string,
  error: PropTypes.bool,
  success: PropTypes.bool,
  white: PropTypes.bool,
  isSubmitted: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
};
